import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "progress-description mt-2" }


export default /*@__PURE__*/_defineComponent({
  __name: 'Progress',
  props: {
  progress: {
    type: Object as PropType<Progress | null>,
    default: null
  }
},
  setup(__props) {


// TODO: Add indeterminate state




return (_ctx: any,_cache: any) => {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!

  return (__props.progress)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createVNode(_component_v_progress_linear, {
          "model-value": __props.progress.percent,
          height: "20",
          color: "primary",
          striped: "",
          rounded: ""
        }, null, 8, ["model-value"]),
        _createElementVNode("p", _hoisted_1, _toDisplayString(__props.progress.status), 1)
      ], 64))
    : (_openBlock(), _createBlock(_component_v_progress_linear, {
        key: 1,
        height: "20",
        color: "primary",
        striped: "",
        rounded: "",
        indeterminate: ""
      }))
}
}

})